export default __webpack_public_path__ + "static/media/23.5c4ec381.mp3";